module.exports = ".n-resize {\n  resize: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss
// module id = ./src/app/shared/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss
// module chunks = main